import {
  Accordion,
  AccordionDetails,
  AccordionDetailsProps,
  AccordionProps,
  AccordionSummary,
  AccordionSummaryProps,
  Box,
} from "@mui/material";
import ArrowDown from "@/icons/ArrowDown";
import { ReactNode } from "react";

const AppAccordion = ({
  accordionProps,
  accordionSummary,
  accordionDetailsProps,
  detailComponent,
  titleComponent,
}: AppAccordionProps) => {
  return (
    <Accordion
      defaultExpanded
      sx={{
        "&&::before": {
          content: "unset",
        },
        "&&": {
          boxShadow: "unset",
          border: "1px solid",
          borderColor: "border.main",
        },
        "&& + &": {
          borderTop: "unset",
        },
        "&&.Mui-expanded": {
          margin: 0,
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ArrowDown sx={{ width: "24px", height: "24px" }} />}
        sx={{
          margin: 0,
          "&&": {
            minHeight: 0,
            boxShadow: "unset",
          },
          padding: "12px 16px 12px 12px",
          "&& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
          "&& .MuiAccordionSummary-content": {
            margin: 0,
          },
        }}
      >
        {titleComponent}
      </AccordionSummary>
      <AccordionDetails className="p-0">{detailComponent}</AccordionDetails>
    </Accordion>
  );
};

export default AppAccordion;
type AppAccordionProps = {
  accordionProps?: AccordionProps;
  accordionSummary?: AccordionSummaryProps;
  accordionDetailsProps?: AccordionDetailsProps;
  detailComponent: ReactNode;
  titleComponent: ReactNode;
};
